var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
var featuredProductCardRequests = new Map();

function getFeaturedProductRequest() {
    var parameters = new URLSearchParams(window.location.search);
    var handles = [];
    var seenHandles = new Set();

    (parameters.get('product') || '').split(',').forEach(function(rawHandle) {
        var handle = rawHandle.trim().toLowerCase();
        if (
            handles.length < 20
            && /^[a-z0-9][a-z0-9-]*$/.test(handle)
            && !seenHandles.has(handle)
        ) {
            seenHandles.add(handle);
            handles.push(handle);
        }
    });

    return {
        tag: (parameters.get('fp_tag') || '').trim().toLowerCase().replace(/-/g, '_'),
        handles: handles,
        debug: parameters.get('fp_debug') === '1'
    };
}

function preserveFeaturedProductParams(rawUrl) {
    var targetUrl = new URL(rawUrl, window.location.origin);
    var currentParameters = new URLSearchParams(window.location.search);

    ['product', 'fp_tag', 'fp_debug', 'preview_theme_id'].forEach(function(parameterName) {
        var parameterValue = currentParameters.get(parameterName);
        if (parameterValue) {
            targetUrl.searchParams.set(parameterName, parameterValue);
        }
    });

    return targetUrl.pathname + targetUrl.search + targetUrl.hash;
}

function syncFeaturedProductUrls(root) {
    var scope = root || document;
    var links = scope.querySelectorAll(
        '.yv-pagination a, #more a, a.yv-applied-filter-remove'
    );

    Array.from(links).forEach(function(link) {
        link.setAttribute('href', preserveFeaturedProductParams(link.getAttribute('href')));
    });
}

function fetchFeaturedProductCard(handle) {
    if (featuredProductCardRequests.has(handle)) {
        return featuredProductCardRequests.get(handle);
    }

    var request = new Promise(function(resolve) {
        var controller = new AbortController();
        var timeoutId = window.setTimeout(function() {
            controller.abort();
        }, 2500);
        var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
        if (!shopRoot.endsWith('/')) {
            shopRoot += '/';
        }
        var productCardUrl = shopRoot + 'products/' + encodeURIComponent(handle) + '?view=featured-card';

        fetch(productCardUrl, {
            credentials: 'same-origin',
            signal: controller.signal
        })
            .then(function(response) {
                if (!response.ok) {
                    return null;
                }
                return response.text();
            })
            .then(function(responseText) {
                if (!responseText) {
                    resolve(null);
                    return;
                }
                var responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
                var productCard = responseDocument.querySelector('[data-featured-product-card]');
                resolve(productCard ? productCard.cloneNode(true) : null);
            })
            .catch(function() {
                resolve(null);
            })
            .finally(function() {
                window.clearTimeout(timeoutId);
            });
    });

    featuredProductCardRequests.set(handle, request);
    return request;
}

function resolveFeaturedHandleCards(handles, productGrid, registry, currentPage) {
    if (currentPage !== 1 || handles.length === 0) {
        return Promise.resolve([]);
    }

    var currentCards = Array.from(productGrid.querySelectorAll('[data-product-grid][data-product-handle]'));
    var templatesByProductId = new Map();
    var productIdsByHandle = new Map();

    Array.from(registry.querySelectorAll('template[data-featured-product-template]')).forEach(function(template) {
        templatesByProductId.set(template.dataset.featuredProductTemplate, template);
    });
    Array.from(registry.querySelectorAll('[data-featured-product-ref]')).forEach(function(reference) {
        if (reference.dataset.featuredProductHandle && reference.dataset.featuredProductRef) {
            productIdsByHandle.set(
                reference.dataset.featuredProductHandle.toLowerCase(),
                reference.dataset.featuredProductRef
            );
        }
    });

    return Promise.all(handles.map(function(handle) {
        var currentCard = currentCards.find(function(card) {
            return card.dataset.productHandle.toLowerCase() === handle;
        });
        if (currentCard) {
            var currentCardClone = currentCard.cloneNode(true);
            currentCardClone.setAttribute('data-featured-product-injected', '');
            return Promise.resolve({
                handle: handle,
                card: currentCardClone,
                source: 'collection-page'
            });
        }

        var registeredProductId = productIdsByHandle.get(handle);
        var registeredTemplate = registeredProductId
            ? templatesByProductId.get(registeredProductId)
            : null;
        if (registeredTemplate && registeredTemplate.content.firstElementChild) {
            return Promise.resolve({
                handle: handle,
                card: registeredTemplate.content.firstElementChild.cloneNode(true),
                source: 'featured-products-registry'
            });
        }

        return fetchFeaturedProductCard(handle).then(function(card) {
            return {
                handle: handle,
                card: card,
                source: card ? 'product-handle-route' : 'not-found'
            };
        });
    }));
}

async function applyFeaturedProductOrdering(root) {
    var startedAt = window.performance ? window.performance.now() : Date.now();
    var scope = root || document;
    var container = scope.matches && scope.matches('#CollectionProductsContainer')
        ? scope
        : scope.querySelector('#CollectionProductsContainer');
    var request = getFeaturedProductRequest();

    if (!container) {
        document.documentElement.classList.remove('featured-products-pending');
        return null;
    }

    var registry = container.querySelector('[data-featured-product-registry]');
    var productGrid = container.querySelector('[data-collection-products]');
    if (!registry || !productGrid) {
        document.documentElement.classList.remove('featured-products-pending');
        return null;
    }

    Array.from(productGrid.querySelectorAll('[data-featured-product-injected]')).forEach(function(product) {
        product.remove();
    });

    var hasActiveFilters = container.dataset.hasActiveFilters === 'true';
    var currentSortBy = container.dataset.currentSortBy || '';
    var defaultSortBy = container.dataset.defaultSortBy || '';
    var hasNonDefaultSort = Boolean(
        currentSortBy
        && defaultSortBy
        && currentSortBy !== defaultSortBy
    );
    var promotionSuppressionReason = '';
    if (hasActiveFilters && hasNonDefaultSort) {
        promotionSuppressionReason = 'active-filters-and-non-default-sort';
    } else if (hasActiveFilters) {
        promotionSuppressionReason = 'active-filters';
    } else if (hasNonDefaultSort) {
        promotionSuppressionReason = 'non-default-sort';
    }

    if (promotionSuppressionReason) {
        syncFeaturedProductUrls(container);
        document.documentElement.classList.remove('featured-products-pending');

        if (request.debug) {
            console.group('[Featured products] Client diagnostics');
            console.log('[Featured products] Promotion suppressed', {
                reason: promotionSuppressionReason,
                hasActiveFilters: hasActiveFilters,
                currentSortBy: currentSortBy,
                defaultSortBy: defaultSortBy,
                fpTag: request.tag,
                featuredProductHandles: request.handles,
                page: parseInt(container.dataset.currentPage || '1', 10),
                url: window.location.href
            });
            console.groupEnd();
        }

        return {
            insertedCount: 0,
            removedDuplicateCount: 0,
            handleResults: [],
            promotionSuppressed: true,
            promotionSuppressionReason: promotionSuppressionReason
        };
    }

    var groups = Array.from(registry.querySelectorAll('[data-featured-product-group]'));
    var selectedGroup = groups.find(function(group) {
        return group.dataset.featuredProductGroup.trim().toLowerCase().replace(/-/g, '_') === request.tag;
    });
    var tagProducts = [];
    var tagProductIds = [];

    if (selectedGroup) {
        var seenProductIds = new Set();
        Array.from(selectedGroup.querySelectorAll('[data-featured-product-ref]')).forEach(function(reference) {
            var productId = reference.dataset.featuredProductRef;
            if (productId && !seenProductIds.has(productId)) {
                seenProductIds.add(productId);
                tagProductIds.push(productId);
                tagProducts.push({
                    id: productId,
                    handle: reference.dataset.featuredProductHandle,
                    title: reference.dataset.featuredProductTitle
                });
            }
        });
    }

    var currentPage = parseInt(container.dataset.currentPage || '1', 10);
    var handleResults = await resolveFeaturedHandleCards(
        request.handles,
        productGrid,
        registry,
        currentPage
    );
    var requestedHandleSet = new Set(request.handles);
    var promotedProductIds = new Set(tagProductIds);
    var removedDuplicateCount = 0;
    Array.from(productGrid.querySelectorAll('[data-product-grid][data-product-id]')).forEach(function(product) {
        var productHandle = (product.dataset.productHandle || '').toLowerCase();
        if (
            promotedProductIds.has(product.dataset.productId)
            || requestedHandleSet.has(productHandle)
        ) {
            product.remove();
            removedDuplicateCount += 1;
        }
    });

    var insertedCount = 0;
    if ((selectedGroup || request.handles.length > 0) && currentPage === 1) {
        var templatesByProductId = new Map();
        Array.from(registry.querySelectorAll('template[data-featured-product-template]')).forEach(function(template) {
            templatesByProductId.set(template.dataset.featuredProductTemplate, template);
        });

        var featuredCards = document.createDocumentFragment();
        var insertedProductIds = new Set();
        var insertedHandles = new Set();

        handleResults.forEach(function(result) {
            if (!result.card) {
                return;
            }
            var productId = result.card.dataset.productId;
            var productHandle = (result.card.dataset.productHandle || result.handle).toLowerCase();
            if (
                (productId && insertedProductIds.has(productId))
                || insertedHandles.has(productHandle)
            ) {
                return;
            }
            if (productId) {
                insertedProductIds.add(productId);
            }
            insertedHandles.add(productHandle);
            result.card.setAttribute('data-featured-product-injected', '');
            featuredCards.appendChild(result.card);
            insertedCount += 1;
        });

        tagProducts.forEach(function(tagProduct) {
            var productId = tagProduct.id;
            var productHandle = (tagProduct.handle || '').toLowerCase();
            if (
                insertedProductIds.has(productId)
                || (productHandle && insertedHandles.has(productHandle))
            ) {
                return;
            }
            var productTemplate = templatesByProductId.get(productId);
            if (productTemplate && productTemplate.content.firstElementChild) {
                featuredCards.appendChild(productTemplate.content.firstElementChild.cloneNode(true));
                insertedProductIds.add(productId);
                if (productHandle) {
                    insertedHandles.add(productHandle);
                }
                insertedCount += 1;
            }
        });
        productGrid.prepend(featuredCards);
    }

    syncFeaturedProductUrls(container);
    document.documentElement.classList.remove('featured-products-pending');

    if (request.debug) {
        var availableGroups = groups.map(function(group) {
            return {
                key: group.dataset.featuredProductGroup,
                type: group.dataset.featuredProductType,
                products: Array.from(group.querySelectorAll('[data-featured-product-ref]')).map(function(reference) {
                    return {
                        id: reference.dataset.featuredProductRef,
                        handle: reference.dataset.featuredProductHandle,
                        title: reference.dataset.featuredProductTitle
                    };
                })
            };
        });
        var finishedAt = window.performance ? window.performance.now() : Date.now();

        console.group('[Featured products] Client diagnostics');
        console.log('[Featured products] Browser request', {
            fpTag: request.tag,
            featuredProductHandles: request.handles,
            page: currentPage,
            url: window.location.href
        });
        console.log('[Featured products] All featured_products.* metafields', availableGroups);
        console.log('[Featured products] Handle resolution', handleResults.map(function(result) {
            return {
                handle: result.handle,
                productId: result.card ? result.card.dataset.productId : null,
                source: result.source
            };
        }));
        console.table(tagProducts);
        console.log('[Featured products] Rendering', {
            selectedGroupFound: Boolean(selectedGroup),
            insertedCount: insertedCount,
            removedDuplicateCount: removedDuplicateCount,
            durationMs: Math.round((finishedAt - startedAt) * 100) / 100
        });
        console.groupEnd();
    }

    return {
        insertedCount: insertedCount,
        removedDuplicateCount: removedDuplicateCount,
        handleResults: handleResults,
        promotionSuppressed: false,
        promotionSuppressionReason: ''
    };
}

function initializeFeaturedProductOrdering() {
    applyFeaturedProductOrdering(document).then(function(result) {
        syncFeaturedProductUrls(document);
        if (result && result.insertedCount > 0) {
            if (typeof productVariants === 'function') {
                productVariants();
            }
            if (typeof gridPickUpAvailability === 'function') {
                gridPickUpAvailability();
            }
            if (typeof productHoverSlider === 'function') {
                productHoverSlider();
            }
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFeaturedProductOrdering, { once: true });
} else {
    initializeFeaturedProductOrdering();
}

if(clearAllButton){
  clearAllFilterButton = true;
}
function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });

    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-4")
            }
        }
        updateGridView(parent);

    }
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    if (hideShowFiltersEvent == false ) {
        if (filterHeading) {
            filterHeading.addEventListener("click", (e) => {
              e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                        }
                    }
                } else {
                    filters.classList.add('active')
                    document.querySelector('body').classList.add('open-filter-popup');
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            });
        }
        hideShowFiltersEvent = true;
    }
}
function hideFilters(){
  var cancelFiltes = document.getElementById('cancelFilters');
  if (cancelFiltes) {
    cancelFiltes.addEventListener("click", (e) => {
      e.preventDefault();
      filters.classList.remove('active')
      document.querySelector('body').classList.remove('open-filter-popup');
      document.querySelector('body').classList.remove('open-filter-sort');
    });
  }
}
window.addEventListener('load', (event) => {
    changeGridLayout();
    hideShowFilters();
    applyFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
  sortBy();
});
window.addEventListener('resize', function(event) {
    changeGridLayout();
    applyFilters();
    hideShowFilters();
    sortByVisibilityChange(); 
    var filters = document.getElementById('filterSideBar');
    if (filters) {
        if (window.innerWidth < 768 && window.innerWidth > 760) {
            filters.style.display = 'none';
            setTimeout(function() { filters.style.display = ''; }, 500)
        }
    }

});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                showMoreFilter.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (showMoreFilter.classList.contains('active')) {
                        showMoreFilter.classList.remove('active');
                        DOMAnimations.slideUp(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showMoreText;
                    } else {
                        showMoreFilter.classList.add('active');
                        DOMAnimations.slideDown(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showLessText;
                    }
                });
            });
        }
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (section) {
        var sectionParent = section.closest('.shopify-section');
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        //   showMultipleOptions(); 
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            layout.addEventListener("click", (e) => {
                e.preventDefault();
                if (!layout.classList.contains('active')) {
                    layout.classList.add('active');
                    let allGrids = section.querySelectorAll('.aos-init');

                    Array.from(allGrids).forEach(function(grid) {
                        grid.classList.remove('aos-animate');
                        grid.classList.remove('aos-init');
                    });

                    setTimeout(function() {
                        Array.from(layouts).forEach(function(layoutItem) {
                            if (layoutItem != layout) {
                                layoutItem.classList.remove('active');
                            }
                        });
                        var _thisLayout = layout.dataset.value;
                        section.setAttribute('data-view', _thisLayout)
                        updateGridView(section);
                        var date = new Date();

                        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
                        Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
                        let allImages = section.querySelectorAll('.lazyloaded');

                        Array.from(allImages).forEach(function(image) {
                            image.classList.remove('lazyloaded');
                            image.classList.add('lazyload');
                        });
                    }, 800);
                }

            });
        });

        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            var sliderEventListener = '';
            if (el.noUiSlider) {
                sliderEventListener = el.noUiSlider;
            } else {
                sliderEventListener = noUiSlider.create(el, {
                    step: 1,
                    connect: true,
                    start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
                    range: {
                        min: [parseFloat(el.dataset.min) || 0],
                        max: [parseFloat(el.dataset.max) || 100]
                    }
                });
            }
            if (window.innerWidth > 767) {
                sliderEventListener.on('change', function(values) {
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseFloat(values[0]);
                    var newformatMoney = moneyFormat;
                    if (minVal >= minRange) {
                        section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                    }
                    var maxVal = parseFloat(values[1]);
                    if (maxVal <= maxRange) {
                        section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                    }
                    if (window.innerWidth > 767) {
                        getFilterData(rangeBar, sectionId);
                    }
                })
            }
            sliderEventListener.on("update", function(values) {
                var minRange = $(this)[0].options.range.min;
                var maxRange = $(this)[0].options.range.max;
                var minVal = parseFloat(values[0]);
                if (minVal >= minRange) {
                    section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                }
                var maxVal = parseFloat(values[1]);
                if (maxVal <= maxRange) {
                    section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                }
            })
        })

        if (window.innerWidth > 767) {
            var prices = filterForm.querySelectorAll('input[type=number]');
            Array.from(prices).forEach(function(price) {
                price.addEventListener("change", () => {
                    getFilterData(price, sectionId)
                });
            });
            var inputs = filterForm.querySelectorAll('input[type=checkbox],input[type=radio]');
            Array.from(inputs).forEach(function(input) {
                input.addEventListener("click", () => {
                  if (window.innerWidth > 767) {
                    getFilterData(input, sectionId)
                  }
                });
            });
        } else {
            filterForm.addEventListener("submit", (e) => {
                e.preventDefault();
                getFilterData(filterForm, sectionId)
                // document.querySelector('body').classList.remove('open-filter-sort');
            });
        }

      var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            if(removeFilter.id == 'yv-applied-filter-cross-all' & clearAllFilterButton == false){
              return false;
            }
          else{
              clearAllFilterButton == false
              removeFilter.addEventListener("click", (e) => {
                  e.preventDefault();
                  var _url = removeFilter.getAttribute('href');
                  getFilterData(removeFilter, sectionId, _url);
              });
            }
        });
    }
}

function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    if(section){
        var sectionId = section.dataset.id;
        Array.from(sortBy).forEach(function(sort) {
            sort.addEventListener("change", (e) => {
                e.preventDefault();
                Array.from(sortBy).forEach(function(sort) {
                    sort.parentNode.classList.remove('selected');
                })

                sort.parentNode.classList.add('selected');
                var sortMenu = document.getElementById('sort__list');
                if(sortMenu){
                    if (sortMenu.classList.contains('active')) {
                        sortMenu.classList.remove('active');
                        if (window.innerWidth > 767) {
                            DOMAnimations.slideUp(sortMenu);
                        } else {
                            document.querySelector('body').classList.remove('open-filter-sort');
                        }
                    }
                }
                document.querySelector('body').classList.remove('open-filter-sort');
                getFilterData(sort, sectionId);
            });
        });
    }
}
function sortByVisibilityChange(){
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');
          
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
          document.querySelector('body').classList.add('open-filter-sort');
          }else{
          document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() {
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu) {          
        sortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (sortMenu.classList.contains('active')) {
                sortMenu.classList.remove('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideUp(sortMenu);
                } else {
                    document.querySelector('body').classList.remove('open-filter-sort');
                }
            } else {
                sortMenu.classList.add('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideDown(sortMenu);
                } else {
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            }
        });
    }
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu) {
        closeSortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (window.innerWidth < 768) {
                sortMenu.classList.remove('active');
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        });
    }
}

function updateGridView(section) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
    }
}

function fetchFilterData(url) {
    return fetch(url)
        .then(response => response.text())
}

function getFilterData(input, sectionId, remove) {
    //   document.getElementById('CollectionProductsContainer').querySelector('.filteredData').classList.add('filtering')

    infinitePaginationPaused = true;
    cancelInfinitePagination();
    let allGrids = document.getElementById('CollectionProductsContainer').querySelectorAll('.aos-init');

    Array.from(allGrids).forEach(function(grid) { 
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    var searchParameters = new URLSearchParams(formData);
    var currentParameters = new URLSearchParams(window.location.search);
    ['product', 'fp_tag', 'fp_debug', 'preview_theme_id'].forEach(function(parameterName) {
        var parameterValue = currentParameters.get(parameterName);
        if (parameterValue) {
            searchParameters.set(parameterName, parameterValue);
        }
    });
    var serializedSearchParameters = searchParameters.toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');
    
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + serializedSearchParameters;
    var _updateUrl = window.location.pathname + '?' + serializedSearchParameters;
    if (remove) {
        var removeUrl = new URL(remove, window.location.origin);
        ['product', 'fp_tag', 'fp_debug', 'preview_theme_id'].forEach(function(parameterName) {
            var parameterValue = currentParameters.get(parameterName);
            if (parameterValue) {
                removeUrl.searchParams.set(parameterName, parameterValue);
            }
        });
        url = removeUrl.pathname + removeUrl.search;
        _updateUrl = url;
    }
    const html = fetchFilterData(url).
    then(async (responseText) => {
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }

        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            }
          else{
            clearAllFilterButton = false;
          }
        }else{
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = document.getElementById('CollectionProductsContainer');
        if (html) {
            elmnt.innerHTML = html.innerHTML;
            elmnt.dataset.currentPage = html.dataset.currentPage || '1';
            elmnt.dataset.hasActiveFilters = html.dataset.hasActiveFilters || 'false';
            elmnt.dataset.currentSortBy = html.dataset.currentSortBy || '';
            elmnt.dataset.defaultSortBy = html.dataset.defaultSortBy || '';
            await applyFeaturedProductOrdering(elmnt);
            syncFeaturedProductUrls(document);
            updateGridView(elmnt);
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        initializeInfinitePagination();

        document.querySelector('body').classList.remove('open-filter-sort');
        document.querySelector('body').classList.remove('open-filter-popup');
        filters = document.getElementById('filterSideBar');
        filterContainer = elmnt;
        let inputId = input.getAttribute('id');
        let updateInput = document.getElementById(inputId);
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;

                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        sortBy();
        applyFilters();
        showMoreFilters();
        if(filters && filters.querySelector('[name="sort_by"]')){
            sortByOptions()
        }
        // hideShowFiltersEvent = false;
        hideFilters();
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
        productVariants();
        gridPickUpAvailability();
        productHoverSlider();
        if (input.getAttribute('name') != 'sort_by' && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ top: 150, behavior: "smooth" });
        }
        history.pushState({}, null, _updateUrl);
    }).catch(function(error) {
        initializeInfinitePagination();
        console.error('[Collection filters] Unable to update the product grid.', error);
    });
}



var infinitePaginationPreloadDistance = 800;
var infinitePaginationObserver = null;
var infinitePaginationVisibilityObserver = null;
var infinitePaginationRequest = null;
var infinitePaginationFallbackFrame = null;
var infinitePaginationPaused = false;

function getInfinitePaginationMarker() {
    var markers = document.querySelectorAll('[data-collection-products] #more');
    return markers.length > 0 ? markers[markers.length - 1] : null;
}

function isInfinitePaginationMarkerVisible(marker) {
    if (!marker || !marker.isConnected) {
        return false;
    }

    var markerBounds = marker.getBoundingClientRect();
    return markerBounds.top < window.innerHeight && markerBounds.bottom > 0;
}

function isInfinitePaginationMarkerNearViewport(marker) {
    if (!marker || !marker.isConnected) {
        return false;
    }

    var markerBounds = marker.getBoundingClientRect();
    return (
        markerBounds.top < window.innerHeight + infinitePaginationPreloadDistance
        && markerBounds.bottom > -infinitePaginationPreloadDistance
    );
}

function updateInfinitePaginationLoader(marker) {
    if (!marker) {
        return;
    }

    var loader = marker.querySelector('.load');
    if (!loader) {
        return;
    }

    var shouldShowLoader = Boolean(
        infinitePaginationRequest
        && infinitePaginationRequest.marker === marker
        && isInfinitePaginationMarkerVisible(marker)
    );
    loader.classList.toggle('hidden', !shouldShowLoader);
}

function disconnectInfinitePaginationObservers() {
    if (infinitePaginationObserver) {
        infinitePaginationObserver.disconnect();
        infinitePaginationObserver = null;
    }
    if (infinitePaginationVisibilityObserver) {
        infinitePaginationVisibilityObserver.disconnect();
        infinitePaginationVisibilityObserver = null;
    }
}

function cancelInfinitePagination() {
    disconnectInfinitePaginationObservers();

    if (infinitePaginationRequest) {
        var requestState = infinitePaginationRequest;
        infinitePaginationRequest = null;
        requestState.cancelled = true;
        updateInfinitePaginationLoader(requestState.marker);
        if (requestState.xhr) {
            requestState.xhr.abort();
        }
    }
}

function finishInfinitePaginationRequest(requestState) {
    if (infinitePaginationRequest !== requestState) {
        return;
    }

    infinitePaginationRequest = null;
    updateInfinitePaginationLoader(requestState.marker);
    initializeInfinitePagination();
}

async function appendInfinitePaginationResponse(data, requestState) {
    if (
        requestState.cancelled
        || infinitePaginationRequest !== requestState
        || !requestState.marker.isConnected
    ) {
        return false;
    }

    var fetchedDocument = new DOMParser().parseFromString(data, 'text/html');
    var fetchedContainer = fetchedDocument.getElementById('CollectionProductsContainer');
    var fetchedProductGrid = fetchedContainer
        ? fetchedContainer.querySelector('[data-collection-products]')
        : null;
    if (!fetchedContainer || !fetchedProductGrid) {
        return false;
    }

    await applyFeaturedProductOrdering(fetchedContainer);
    if (
        requestState.cancelled
        || infinitePaginationRequest !== requestState
        || !requestState.marker.isConnected
    ) {
        return false;
    }

    updateGridView(fetchedContainer);
    var currentProductGrid = document.querySelector('[data-collection-products]');
    if (!currentProductGrid) {
        return false;
    }

    requestState.marker.remove();
    currentProductGrid.insertAdjacentHTML('beforeend', fetchedProductGrid.innerHTML);
    syncFeaturedProductUrls(document);
    productVariants();
    gridPickUpAvailability();
    productHoverSlider();
    if(animationStatus){
      if (AOS) {
        AOS.refreshHard()
      }
    }
    return true;
}

function loadNextCollectionPage(marker) {
    if (
        infinitePaginationPaused
        || !marker
        || infinitePaginationRequest
        || marker.dataset.infinitePaginationFailed === 'true'
    ) {
        return;
    }

    var nextPageLink = marker.querySelector('a[href]');
    if (!nextPageLink) {
        return;
    }

    var requestState = {
        marker: marker,
        xhr: null,
        cancelled: false
    };
    infinitePaginationRequest = requestState;
    if (infinitePaginationObserver) {
        infinitePaginationObserver.disconnect();
        infinitePaginationObserver = null;
    }
    updateInfinitePaginationLoader(marker);

    requestState.xhr = $.ajax({
        url: nextPageLink.getAttribute('href'),
        type: 'GET'
    });
    requestState.xhr.done(function(data) {
        appendInfinitePaginationResponse(data, requestState)
            .then(function(appended) {
                if (
                    !appended
                    && infinitePaginationRequest === requestState
                    && requestState.marker.isConnected
                ) {
                    requestState.marker.dataset.infinitePaginationFailed = 'true';
                }
            })
            .catch(function(error) {
                if (
                    infinitePaginationRequest === requestState
                    && requestState.marker.isConnected
                ) {
                    requestState.marker.dataset.infinitePaginationFailed = 'true';
                }
                console.error('[Infinite pagination] Unable to append the next page.', error);
            })
            .finally(function() {
                finishInfinitePaginationRequest(requestState);
            });
    });
    requestState.xhr.fail(function(_request, status) {
        if (status !== 'abort' && requestState.marker.isConnected) {
            requestState.marker.dataset.infinitePaginationFailed = 'true';
        }
        finishInfinitePaginationRequest(requestState);
    });
}

function handleInfinitePaginationFallback() {
    if (infinitePaginationFallbackFrame) {
        return;
    }

    infinitePaginationFallbackFrame = window.requestAnimationFrame(function() {
        infinitePaginationFallbackFrame = null;
        var marker = getInfinitePaginationMarker();
        updateInfinitePaginationLoader(marker);
        if (infinitePaginationPaused) {
            return;
        }
        if (!isInfinitePaginationMarkerNearViewport(marker)) {
            if (marker) {
                delete marker.dataset.infinitePaginationFailed;
            }
            return;
        }
        if (!infinitePaginationRequest) {
            loadNextCollectionPage(marker);
        }
    });
}

function initializeInfinitePagination() {
    infinitePaginationPaused = false;
    disconnectInfinitePaginationObservers();
    var marker = getInfinitePaginationMarker();
    if (!marker) {
        return;
    }

    syncFeaturedProductUrls(document);
    if (!('IntersectionObserver' in window)) {
        handleInfinitePaginationFallback();
        return;
    }

    infinitePaginationVisibilityObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.target === marker) {
                updateInfinitePaginationLoader(marker);
            }
        });
    });
    infinitePaginationVisibilityObserver.observe(marker);

    infinitePaginationObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && entry.target === marker) {
                loadNextCollectionPage(marker);
            } else if (!entry.isIntersecting && entry.target === marker) {
                delete marker.dataset.infinitePaginationFailed;
            }
        });
    }, {
        rootMargin: '0px 0px ' + infinitePaginationPreloadDistance + 'px 0px'
    });
    infinitePaginationObserver.observe(marker);
}

$(document).ready(function() {
    initializeInfinitePagination();
    if (!('IntersectionObserver' in window)) {
        $(window).on('scroll resize', handleInfinitePaginationFallback);
    }
});
